import { render } from "./TkCaseNotesPanel.vue?vue&type=template&id=3c1d476c&scoped=true"
import script from "./TkCaseNotesPanel.vue?vue&type=script&lang=js"
export * from "./TkCaseNotesPanel.vue?vue&type=script&lang=js"

import "./TkCaseNotesPanel.vue?vue&type=style&index=0&id=3c1d476c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1d476c"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QField from 'quasar/src/components/field/QField.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QBanner,QBtn,QForm,QSelect,QInput,QCheckbox,QField,QBtnToggle,QFile,QIcon,QList,QItem,QItemSection,QItemLabel,QTooltip,QSeparator,QInnerLoading});
